/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { countries } from './wine-club-countries.data';
import { IWineClubResources } from './wine-club.props.autogenerated';
import { inputType } from './wine-club.types';

// tslint:disable-next-line:max-func-body-length
export const getInputs = (resources: IWineClubResources): inputType[] => {
    return [
        {
            id: 'membership',
            label: resources.wineClub_membershipTypeLabel,
            required: true,
            type: 'radio',
            options: [
                resources.wineClub_membershipTypeOptionIsNotGifted,
                resources.wineClub_membershipTypeOptionIsGifted
            ],
            validation: {
                validate: (value: string): boolean => {
                    return !!value;
                },
                message: resources.wineClub_membershipTypeValidationMessage
            }
        },
        {
            id: 'firstName',
            group: 'shippingAddress',
            label: 'First Name',
            required: true,
            type: 'text',
        },
        {
            id: 'lastName',
            group: 'shippingAddress',
            label: 'Last Name',
            required: true,
            type: 'text',
        },
        {
            id: 'email',
            group: 'shippingAddress',
            label: 'Email Address',
            required: true,
            type: 'text',
            validation: {
                validate: (value: string): boolean => {
                    const email = /^[-a-z0-9!#$%&'*+/=?^_`{|}~]+(?:\.[-a-z0-9!#$%&'*+/=?^_`{|}~]+)*@(?:[a-z0-9]+(?:-+[a-z0-9]+)*\.)+(?:xn--[a-z0-9]+|[a-z]{2,16})$/i;
                    return !!(value && value.match(email));
                },
                message: 'Enter a valid email address.'
            }
        },
        {
            id: 'phone',
            group: 'shippingAddress',
            label: 'Phone Number',
            required: true,
            type: 'text',
            validation: {
                validate: (value: string): boolean => {
                    const phone = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
                    return !!(value.match(phone));
                },
                message: 'Enter a valid phone number.'
            }
        },
        {
            id: 'address1',
            group: 'shippingAddress',
            label: 'Address 1',
            required: true,
            type: 'text',
        },
        {
            id: 'address2',
            group: 'shippingAddress',
            label: 'Address 2',
            required: false,
            type: 'text',
        },
        {
            id: 'city',
            group: 'shippingAddress',
            label: 'City',
            required: true,
            type: 'text',
        },
        {
            id: 'state',
            group: 'shippingAddress',
            label: 'State',
            required: true,
            type: 'text',
        },
        {
            id: 'zip',
            group: 'shippingAddress',
            label: 'Zip',
            required: true,
            type: 'text',
        },
        {
            id: 'country',
            group: 'shippingAddress',
            label: 'Country',
            required: true,
            type: 'select',
            options: countries
        }
    ];
};

// tslint:disable-next-line: no-empty-interface
export interface IWineClubInputData {}